import { FC } from "react";

import { Box, VStack } from "@chakra-ui/react";
import { Image } from "antd";
import { useIdentity } from "context/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

const EbayActiveListings: FC = () => {
    const { userName } = useIdentity();
    return (
        <VStack justifyContent="space-between" height="100%" width="100%">
            <Box />
            <VStack spacing={1} padding={2}>
                <Box fontWeight="semibold" fontSize="lg">
                    View {userName}'s Listings on
                </Box>
                <Image
                    preview={false}
                    src="/img/ebay.svg"
                    alt="ebay"
                    style={{
                        height: 36,
                    }}
                />
            </VStack>
            <Box alignSelf="end">
                <FontAwesomeIcon
                    icon={faArrowUpRightFromSquare}
                    color="#9ca3af"
                    size="lg"
                />
            </Box>
        </VStack>
    );
};

export default EbayActiveListings;
